
import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';


import PageLayout from '../../components/PageLayout';
import { GET, GETWITH, JSXMap, QueryParam, errorCatch, useAuth, useNavigation, useUserContext } from 'fennec-ui';
import { BreadcrumbsProvider, NearestObjectContext, useBreadcrumbs } from '../../../common/Context';

import EventListItem from '../EventListItem';
import ObjectVtpDescription from '../../../fedance-ui/ObjectVtpDescription';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import ObjectContextDescription from '../../../fedance-ui/ObjectContextDescription';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { UserName } from '../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

// export function ContextElement(props) {
//     const { item, displayString } = props;
//     return (<div key={item?.ID} className='element bg bg-fwhite' style={{ textAlign: "left", padding: "3px 0" }}>
//         <div className='element-slot'>
//             <i className="fa fa-circle" style={{ fontSize: "8px", color: "rgb(2, 192, 203)" }}></i>
//         </div>
//         <div className='element-wrapper'>
//             <div className='element-content'>
//                 <div className='element-content-body'>
//                     <a href={`${item.ID}`}>{displayString(item)}</a>
//                 </div>
//             </div>
//             <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
//                 {item?.dataVstupleniya && <div>Дата регистрации: {dayjs(e?.dataVstupleniya).format("DD.MM.YYYY HH:mm")}</div>}
//             </div>
//         </div>
//     </div>)
// }

export function ContextLocaladminElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;

    return (<div onClick={() => { navigate(`/app/local/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.nazvanie}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataVstupleniya && <div>Дата регистрации: {dayjs(item?.dataVstupleniya).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></div>)
}

export function ContextSchoolElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;
    return (<div onClick={() => { navigate(`/app/school/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.nazvanieShkoliTantsev}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                <div>Региональное отделение:
                    <span style={{ fontStyle: "italic" }}> {item?.regionalnoeOtdelenie?.nazvanie}</span>
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 18)?.map(e => {
                    return (<div>Владелец:
                        <span style={{ fontStyle: "italic" }}> {e?.user?.lastname} {e?.user?.firstname}</span>
                    </div>)
                })}
            </div>
        </div>
    </div></div>)
}

export function ContextOrganizerElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;
    return (<div onClick={() => { navigate(`/app/organizer/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.nazvanie}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></div>)
}

export function ContextTeacherElement(props) {
    const navigate = useNavigate()
    const user = useUserContext();
    const { item, color } = props;
    return (<div onClick={() => { navigate(`/app/teacher/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: (item?.user?.ID === user?.ID) ? color : "grey" }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.regionalnoeOtdelenie?.nazvanie}
                </div>
                {(item?.user?.ID != user?.ID) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    <UserName item={item?.user} noborder={true} noicon={true} />
                </div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></div>)
}

export function ContextTestingAdminElement(props) {
    const navigate = useNavigate()
    const { item, color, style } = props;

    const x = useBreadcrumbs()
    // console.log(`/app${x.map(o=>`/${o.uuid}`)}/${item.ID}`);
    // console.log(item);
    let path = "/app" + x.map(o => `/${o.uuid}`).join("");

    return (<div onClick={() => { navigate(`${path}/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: (item?.done) ? (item?.nabranniiProtsent >= item?.prokhodnoiProtsent && item?.countErrorProtocoli <= item?.dopustimoeKolvoOshibokProtokolov) ? "green" : "red" : "gray" }}></i>
        </div>
        <div className='element-wrapper' style={{
            backgroundColor: (item?.passed) ? "#dcf5e6" : "transparent",
            padding: "3px 7px",
            borderRadius: "5px"
        }}>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.sudya.user.lastname} {item?.sudya.user.firstname} ({item?.sudya?.regionalnoeOtdelenie?.nazvanie}), {item?.kategoriyaSudeistva?.nazvanieKategorii + " - " + item?.kategoriyaSudeistva?.tanets.nazvanie}, {item?.shablon?.nazvanie}
                </div>
                {item?.certificateNumber && <div style={{ fontSize: "12px", fontStyle: "italic" }}>Сертификат: {item?.certificateNumber}</div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                <div>
                    <div>
                        {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")} {(item?.done) ? "(завершен)" : "(не завершен)"}</div>}
                    </div>
                    {item?.done && <div>
                        Тест {(item?.nabranniiProtsent >= item?.prokhodnoiProtsent && item?.countErrorProtocoli <= item?.dopustimoeKolvoOshibokProtokolov) ? "пройден!" : "не пройден."} Результат: <span style={{ color: (item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "green" : "red" }}>{item?.nabranniiProtsent}%</span>, набрано {item?.summaBallov} баллов из {item?.vsegoBallovVTeste}{(item?.vsegoProtokolov > 0) ? (item?.nepravilnieProtokli != 0) ? <span>, <span style={{ color: "red" }}>есть неправильные протоколы</span></span> : <span>, <span style={{ color: "green" }}>протоколы корректны</span></span> : ""}
                    </div>}
                </div>
            </div>
        </div>
    </div></div>)
}
export function ContextTestingElement(props) {
    const navigate = useNavigate()
    const { item, color, style } = props;

    // const x = useBreadcrumbs()
    // console.log(`/app${x.map(o=>`/${o.uuid}`)}/${item.ID}`);
    // console.log(item);

    return (<div onClick={() => { navigate(`/app/testing/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: (item?.done) ? (item?.nabranniiProtsent >= item?.prokhodnoiProtsent && item?.countErrorProtocoli <= item?.dopustimoeKolvoOshibokProtokolov) ? "green" : "red" : "gray" }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.kategoriyaSudeistva?.nazvanieKategorii + " - " +
                        item?.kategoriyaSudeistva?.tanets.nazvanie}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                <div>
                    <div>
                        {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")} {(item?.done) ? "(завершен)" : "(не завершен)"}</div>}
                    </div>
                    {item?.done && <div>
                        Тест {(item?.nabranniiProtsent >= item?.prokhodnoiProtsent && item?.countErrorProtocoli <= item?.dopustimoeKolvoOshibokProtokolov) ? "пройден!" : "не пройден."} Результат: <span style={{ color: (item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "green" : "red" }}>{item?.nabranniiProtsent}%</span>, набрано {item?.summaBallov} баллов из {item?.vsegoBallovVTeste}{(item?.vsegoProtokolov > 0) ? (item?.nepravilnieProtokli != 0) ? <span>, <span style={{ color: "red" }}>есть неправильные протоколы</span></span> : <span>, <span style={{ color: "green" }}>протоколы корректны</span></span> : ""}
                    </div>}
                </div>
            </div>
        </div>
    </div></div>)
}

export function ContextAutomationElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;
    return (<div onClick={() => { navigate(`/app/automation/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ color: "var(--bs-link-color)" }}>
                    {item?.name}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></div>)
}

export function ContextEventSellingElement(props) {
    const { item, color } = props;
    const navigate = useNavigate()
    return (<div onClick={() => { navigate(`/app/common/selling/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        {/* <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div> */}
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ padding: "0 7px" }}>
                    {/* {item?.nazvanieMeropriyatiya} - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "mestoProvedeniya.name")} */}
                    {/* <span>{item?.nazvanieMeropriyatiya}</span> - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(item?.mestoProvedeniya)? "("+item?.mestoProvedeniya?.name+")":""} */}
                    <EventListItem
                        key={"event"}
                        event={item}
                        hideRoles={true}
                        size="small"
                        hidePreview={true}
                        noNameLink={true}
                        hideBuyButton={true}
                        extButtons={({ path, size, style }) => [
                            <div key="view">
                                <div
                                    style={style}
                                    className={`btn btn-soft-secondary btn-sm`}
                                    onClick={() => { navigate(`${path(1)}/${item.ID}`) }}
                                >
                                    Продажи
                                </div>
                            </div>
                        ]}
                    />
                </div>
            </div>
            {/* <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
            </div> */}
        </div>
    </div></div>)
}
export function ContextGetpromoElement(props) {
    const { item, color } = props;
    const navigate = useNavigate()
    return (<div onClick={() => { navigate(`/app/getpromo/${item.ID}`) }}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        {/* <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div> */}
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' style={{ padding: "0 7px" }}>
                    {/* {item?.nazvanieMeropriyatiya} - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "mestoProvedeniya.name")} */}
                    {/* <span>{item?.nazvanieMeropriyatiya}</span> - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(item?.mestoProvedeniya)? "("+item?.mestoProvedeniya?.name+")":""} */}
                    <EventListItem
                        key={"event"}
                        event={item}
                        hideRoles={true}
                        size="small"
                        hidePreview={true}
                        noNameLink={true}
                        hideBuyButton={true}
                        extButtons={({ path, size, style }) => [
                            <div key="view">
                                <div
                                    style={style}
                                    className={`btn btn-soft-secondary btn-sm`}
                                    onClick={() => { navigate(`${path(1)}/${item.ID}`) }}
                                >
                                    Получить промокод
                                </div>
                            </div>
                        ]}
                    />
                </div>
            </div>
            {/* <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
            </div> */}
        </div>
    </div></div>)
}

export function ContextRoleElement(props) {
    const { item, color } = props;

    const navigate = useNavigate()
    const x = useBreadcrumbs()
    let path = "/app" + x.map(o => `/${o.uuid}`).join("");

    let vtp = _.get(item, "_role");
    let ID = _.get(item, "_role.ID");

    return (<div key={ID} onClick={() => { navigate(`${path}/${ID}`) }}>
        <div key={ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
            <div className='element-slot'>
                <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
            </div>
            <div className='element-wrapper'>
                <div className='element-content'>
                    <div className='element-content-body'>
                        <div style={{ color: "var(--bs-link-color)" }}>
                            <ObjectVtpDescription object={vtp} inline={true} alt={item} />
                        </div>
                        {vtp && <div style={{
                            fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{vtp?.tipPolzovatelya?.opisanie}</div>}
                    </div>
                </div>
                <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
                </div>
            </div>
        </div>
    </div>)
}